import { has } from 'lodash'

/**
 * Determines if a product is an SMB program (reward program) based on its attributes
 * @param {Object} product - The product object or an object containing a product property
 * @returns {boolean} - True if this is an SMB program, false otherwise
 */
export default function isSmbProgram(product) {
    // If product is falsy, it's not an SMB program
    if (!product) {
        return false
    }

    // If the object has a product property, check if it's an SMB program
    if (has(product, 'product')) {
        return (
            (has(product, 'product.cobrand_uuid') &&
                product.product.cobrand_uuid) ||
            (has(product, 'product.saved_design.cobrand_uuid') &&
                product.product.saved_design.cobrand_uuid)
        )
    }

    // If the object is a product itself, check directly
    return (
        (has(product, 'cobrand_uuid') && product.cobrand_uuid) ||
        (has(product, 'saved_design.cobrand_uuid') &&
            product.saved_design.cobrand_uuid)
    )
}
